export function getCookie(cname: string) {
  const name = cname + '='
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let c of ca) {
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export function setCookie(name: string, value: string) {
  document.cookie = `${name}=${value};`
}

export function setThemeCookie(value: string) {
  document.cookie = `theme=${value};domain=${window.location.hostname
    .split('.')
    .splice(-2, 2)
    .join('.')}; path=/`
}

export function getThemeLocalStorage(value: string) {
  const parseValue = JSON.parse(localStorage.getItem(value) || '"light"')
  const theme = parseValue[0].toUpperCase() + parseValue.slice(1)
  return theme || ''
}

export function setThemeLocalStorage(value: string) {
  localStorage.setItem('__BD:themePreference', `"${value.toLowerCase()}"`)
  localStorage.setItem('__BD:pendingPreference', `"${value.toLowerCase()}"`)
}
